import {useEffect, useState} from "react";
import JSONParser from '@core/scripts/helper/json-parser';

export function useSearchHistory() {
    const [recentSearches, setRecentSearches] = useState([]);

    useEffect(() => {
        const history = localStorage.getItem('searchHistory');
        if (history) {
            setRecentSearches(JSONParser.tryParseJSON(history)?.reverse().slice(0,10));
        }
    }, []);

    const addToSearchHistory = (searchValue) => {
        let searchHistory = JSONParser.tryParseJSON(localStorage.getItem('searchHistory')) || [];
        searchHistory = searchHistory.filter((item) => item !== searchValue);
        searchHistory.push(searchValue);
        localStorage.setItem('searchHistory', JSON.stringify(searchHistory));
        setRecentSearches(searchHistory);
    };

    const clearSearchHistory = () => {
        localStorage.removeItem('searchHistory');
        setRecentSearches([]);
    };

    return { recentSearches, addToSearchHistory, clearSearchHistory };
}